import FadedText from "@components/FadedText";
import { Column, Row } from "@components/Layout";
import UserIcon from "@components/UserIcon";
import Waves from "@components/Waves";
import PlayButton from "@layouts/App/context/Player/components/PlayButton";
import usePlay from "@layouts/App/context/Player/hooks/usePlay";
import type { VoidComponent } from "solid-js";
import { ModeButtonWrapper } from "./styled";

const ModeButton: VoidComponent<{
	name: string;
	photo: string;
	source: string;
	voice_code: string;
	onClick: () => void;
}> = (props) => {
	const { playTTSVoiceSample } = usePlay();

	return (
		<ModeButtonWrapper onclick={props.onClick}>
			<UserIcon src={props.photo} diameter="100px" />
			<FadedText>{props.name}</FadedText>
			<Row alignItems="center" justifyContent="center" gap="5px">
				<PlayButton
					diameter="30px"
					onClick={() => playTTSVoiceSample(props.name, props.source, props.voice_code, props.photo)}
				/>
				<Column w="120px">
					<Waves count={6} progress={0} seed={props.voice_code} h="20px" />
				</Column>
			</Row>
		</ModeButtonWrapper>
	);
};
export default ModeButton;
